import _ from 'lodash'
const defaultFeatureSettings = {
  'dicta token': {
    settings: {
      'featureSettings': {'type': 'DICTA_TOKEN', 'nGram': 1},
      'normalizationType': 'FRACTION',
      'numBestFeaturesPerClass': 250
    },
    active: true
  },
  'words': {
    settings: {
      'featureSettings': {'type': 'WORDS', 'filter': 'TEXT_ONLY', 'nGram': 1},
      'normalizationType': 'FRACTION',
      'numBestFeaturesPerClass': 250
    },
    active: false
  },
  'lexemes': {
    settings: {
      'featureSettings': {'type': 'LEXEMES', filter: '\u200e'},
      'normalizationType': 'FRACTION',
      'numBestFeaturesPerClass': 250
    },
    active: false
  },
  'morphology': {
    settings: {
      // the morphology filter removes the lexeme. We should probably introduce a named filter instead of an
      // inscrutable regex, but this works for now
      'featureSettings': {'type': 'MORPHOLOGY', filter: '(?<=@)[^#]+'},
      'normalizationType': 'FRACTION',
      'numBestFeaturesPerClass': 250
      // 'numBestFeaturesOverall': 10
    },
    active: true
  },
  'syntaxClauseTypes': {
    settings: {
      'featureSettings': {'type': 'SYNTAX_CLAUSE_TYPES'},
      'numBestFeaturesPerClass': 250,
      'normalizationType': 'FRACTION'
    },
    active: true
  }
}

export default {
  getDefaultFeatureSettings () {
    return _.cloneDeep(defaultFeatureSettings)
  },
  getDefaultRemovedFeatures () {
    return _.fromPairs(Object.keys(defaultFeatureSettings).map(featureSetName => [featureSetName, []]))
  },
  getDefaultChunking () {
    return 'DEFAULT'
  }
}



// WEBPACK FOOTER //
// ./src/store/defaultSettings.js